import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { IMPERIAL } from 'shared/units/constants'

import {
  GOAL_TYPES,
} from '../shared/constants'

export default function GoalDescription (props) {
  const { goalType, value, system } = props

  return (
    <span>
      {goalType === GOAL_TYPES.distance.key ?
        <FormattedMessage
          id='creategoal.desc.distance'
          defaultMessage={'{value} {label}'}
          values={{
            value: value,
            label: (system === IMPERIAL) ? 'mi' : 'km',
          }} /> : null}

      {goalType === GOAL_TYPES.duration.key ?
        <FormattedMessage
          id='creategoal.desc.duration'
          defaultMessage={'{value} {value, plural, one {hour} other {hours}}'}
          values={{
            value: value,
          }} /> : null}

      {goalType === GOAL_TYPES.workouts.key ?
        <FormattedMessage
          id='creategoal.desc.workouts'
          defaultMessage={'{numOfWorkouts} {numOfWorkouts, plural, one {workout} other {workouts}}'}
          values={{
            numOfWorkouts: value,
          }} /> : null}
    </span>
  )
}

GoalDescription.propTypes = {
  goalType: PropTypes.string,
  value: PropTypes.string,
  system: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/goals/create/GoalDescription.jsx